module.exports = "/dashboard/manage/users/createMultipleUsers-534f93.html";